import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography } from "@mui/material";

// Sample data based on your table
const data = [
  { airline: "Pakistan International Airlines", consumption: 45 },
  { airline: "Fly Jinnah", consumption: 30 },
  { airline: "Air Blue", consumption: 15 },
  { airline: "Serene Air", consumption: 10 },
];

const AirlineConsumptionChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" tickFormatter={(value) => `${value}%`} />
        <YAxis dataKey="airline" type="category" />
        <Tooltip formatter={(value) => `${value}%`} />
        <Bar dataKey="consumption" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AirlineConsumptionChart;
